import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { between, Device, from } from '@helpers/media';
import styled from 'styled-components';
const Nav = styled.nav `
  display: none;

  @media ${from(Device.TabletLarge)} {
    display: flex;
    height: var(--headerNavHeight);
  }
`;
const List = styled.ul `
  display: inherit;
  gap: 0 ${fluid(40, 60)};

  @media ${between(Device.TabletLarge, Device.DesktopLarge)} {
    gap: 0 ${fluid(16, 40)};

    [data-reduce-search='true'] & {
      gap: 0 ${fluid(22, 40, Device.DesktopSmall)};
    }
  }
`;
const Item = styled.li `
  position: relative;
  display: flex;
  place-items: center;
`;
const Link = styled.a `
  display: inline-flex;
  align-items: center;
  gap: 0 10px;
  position: relative;
  ${fonts.ubuntu.medium}
  color: ${brand.primary.purple.base};
  text-decoration: none;
  font-size: ${fluid(14, 18, Device.TabletLarge)};

  &::before {
    position: absolute;
    bottom: -8px;
    left: 0;
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    transform: scaleX(0);
    transform-origin: left;
    background-color: ${brand.primary.purple.base};
    ${transition('transform', '0.15s', 'ease-out')}
  }

  svg {
    --svgSize: ${fluid(10, 12, Device.DesktopSmall)};

    width: var(--svgSize);
    height: var(--svgSize);
    margin-bottom: -2px;
    flex-shrink: 0;
    ${transition('transform', '0.15s', 'ease-out')};
  }

  &:hover,
  &:focus-visible,
  [aria-expanded='true'] > & {
    &::before {
      transform: scaleX(1);
    }

    svg {
      transform: rotate(180deg);
    }
  }
`;
const NavigationStyles = {
    Nav,
    List,
    Item,
    Link,
};
export default NavigationStyles;
